import React from 'react'
import { Modal } from '@zambezi/sdk/modal'
import modalStyle from '@apiEnabler/ob-common/lib/view/modal.module.css'

const ContinueAccessModal = ({ open, onCancel }) => (
  <Modal
    className={`${modalStyle.modal} js-modal`}
    title="How to continue access"
    withBackdrop
    withPadding
    open={open}
    onCancel={onCancel}
    renderFooter={(_, onCancel) => {
      return (
        <div className="zb-modal-card-foot-actions">
          <button
            className="js-cancel-action zb-button zb-button-primary zb-modal-action"
            onClick={onCancel}
          >
            Back to agreement details
          </button>
        </div>
      )
    }}
  >
    <div className="zb-modal-body js-modal-body">
      To renew this agreement, please do so on the service provider site.
    </div>
  </Modal>
)

export default ContinueAccessModal
